import { render } from "./FilterMandates.vue?vue&type=template&id=4e65ad24&scoped=true"
import script from "./FilterMandates.vue?vue&type=script&lang=js"
export * from "./FilterMandates.vue?vue&type=script&lang=js"

import "./FilterMandates.vue?vue&type=style&index=0&id=4e65ad24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e65ad24"]])

export default __exports__